const UPDATE_ITEM_RESOURCES_STATE_MAIN = 'UPDATE_ITEM_RESOURCES_STATE_MAIN';

export default { UPDATE_ITEM_RESOURCES_STATE_MAIN };
